import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { UserRoleNames } from "../../../../core/models/users";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { GiteaService } from "src/app/core/services/gitea.service";
import {
  CloneRepositoryInfo,
  Repository,
} from "../../../../core/models/repository";
import { AddLocalRepoComponent } from "../../modals/add-local-repo/add-local-repo.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SelectRepoUserComponent } from "../../modals/select-repo-user/select-repo-user.component";
import { UserService } from "src/app/core/services/user.service";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { EnvironmentService } from "src/app/core/services/environment.service";
import { GiteaRepository } from "src/app/core/models/gitea";

@Component({
  selector: "app-local-repo-list",
  templateUrl: "./local-repo-list.component.html",
  styleUrl: "./local-repo-list.component.scss",
})
export class LocalRepoListComponent implements OnInit {
  repoList: Repository[];
  filteredRepoList: GiteaRepository[];
  isDataAvailable: boolean = true;
  sortName = 0;
  sortType = 0;
  detailsViewOpen: boolean = false;
  sortServerAddress = 0;
  filterText: string = "";
  p: number = 1;
  userList: string[] = [];
  isMonitor: boolean =
    this.authenticationService?.currentUserValue?.role == UserRoleNames.Reader
      ? true
      : false;
  isGlobalAdmin = this.authenticationService.isUserGlobalAdmin;
  registeredUsers: string[] = [];
  giteaRepoList: GiteaRepository[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private giteaService: GiteaService,
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    private userService: UserService,
    private configEntityService: ConfigEntityService,
    private _env: EnvironmentService
  ) {}

  ngOnInit(): void {
    this.getRegisteredUserGitea();
    this.loadGiteaRepo();
    this.userService.getUserNameList().subscribe({
      next: (data) => {
        this.userList = <string[]>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        this.snackBar.open("Failed to load user list", "Ok", {
          duration: 3000,
        });
      },
    });
    this.spinner.show("repoListSpinner");
  }

  getRegisteredUserGitea() {
    this.giteaService.getGiteaRegisteredUsers().subscribe({
      next: (data: []) => {
        data.forEach((user: any) => {
          this.registeredUsers.push(user.username.toString());
        });
      },
      error: (err) => {},
    });
  }

  addLocalRepo() {
    const dialogRef = this.dialog.open(AddLocalRepoComponent, {
      width: "600px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      autoFocus: false,
      disableClose: true,
      panelClass: "migration-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.snackBar.open("Repository migration started successfully", "Ok", {
          duration: 5000,
        });
        // Refresh the repository list
        this.loadGiteaRepo();
      }
    });
  }

  loadGiteaRepo() {
    this.spinner.show("repoListSpinner");
    this.giteaService.getGiteaReposAll().subscribe({
      next: (data) => {
        this.spinner.hide("repoListSpinner");
        this.giteaRepoList = <GiteaRepository[]>(
          JSON.parse(JSON.stringify(data))
        );
        this.filteredRepoList = [...this.giteaRepoList];
        if (this.giteaRepoList.length == 0) {
          this.isDataAvailable = false;
        } else {
          this.isDataAvailable = true;
        }
      },
      error: (err) => {
        this.spinner.hide("repoListSpinner");
        this.isDataAvailable = false;
      },
    });
  }

  showRegisteredUsers() {
    const editUserDialog = this.dialog.open(SelectRepoUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      height: "600px",
      data: {
        UserList: this.registeredUsers,
        title: "Registered Users on Gitea",
        cancelButtonText: "Close",
        confirmButtonText: "OK",
        showActions: false,
      },
    });
  }

  togglePodView(repo: GiteaRepository) {
    if (!this.detailsViewOpen) {
      this.giteaService.activeRepo = repo;
      // this.router.navigate([node.vmName, "Details"], { relativeTo: this.route });
      this.giteaService.updateSelectedRepo(repo);
      this.detailsViewOpen = true;
    } else {
      this.detailsViewOpen = false;
    }
  }

  closeRepoDetails() {
    this.detailsViewOpen = false;
    this.giteaService.updateSelectedRepo(null);
  }

  createGiteaUser() {
    const editUserDialog = this.dialog.open(SelectRepoUserComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      height: "600px",
      data: {
        UserList: this.userList,
        title: "Add Users to Gitea",
        cancelButtonText: "Cancel",
        confirmButtonText: "Add Users",
      },
    });
    let accountUser = [];
    editUserDialog.afterClosed().subscribe((res) => {
      if (res.status) {
        res.data.forEach((user) => {
          accountUser.push(user);
        });
        this.spinner.show("repoListSpinner");
        this.giteaService.createGiteaUserAccount(accountUser).subscribe({
          next: (data) => {
            this.spinner.hide("repoListSpinner");
            this.snackBar.open("User account creating in background", "Ok", {
              duration: 5000,
            });
          },
          error: (err) => {
            this.spinner.hide("repoListSpinner");
            this.snackBar.open("Failed create account ..", "Ok", {
              duration: 5000,
            });
          },
        });
      }
    });
  }

  addCollaboratorToRepo(repo: GiteaRepository) {
    // First get existing collaborators for this repo
    this.spinner.show("repoListSpinner");
    this.giteaService
      .getRepoCollaborators(repo.owner.username, repo.name)
      .subscribe({
        next: (collaborators: any[]) => {
          this.spinner.hide("repoListSpinner");
          // Extract collaborator usernames
          const existingCollaborators = collaborators.map((collab) => {
            if (typeof collab === "string") {
              return collab;
            }
            return collab.username || collab.login;
          });

          // Filter out users who are already collaborators
          const availableUsers = this.registeredUsers.filter(
            (user) => !existingCollaborators.includes(user)
          );

          if (availableUsers.length === 0) {
            this.snackBar.open(
              "All registered users are already collaborators",
              "Ok",
              {
                duration: 3000,
              }
            );
            return;
          }

          const editUserDialog = this.dialog.open(SelectRepoUserComponent, {
            autoFocus: false,
            disableClose: true,
            width: "400px",
            height: "600px",
            data: {
              UserList: availableUsers,
              title: "Add Users as Collaborators to " + repo.name,
              cancelButtonText: "Cancel",
              confirmButtonText: "Add",
            },
          });

          let collaboratorUser: string[] = [];
          editUserDialog.afterClosed().subscribe((res) => {
            if (res.status) {
              res.data.forEach((user) => {
                collaboratorUser.push(user);
              });
              this.spinner.show("repoListSpinner");
              this.giteaService
                .addCollaboratorToRepo(
                  repo.owner.username,
                  repo.name,
                  collaboratorUser
                )
                .subscribe({
                  next: (data) => {
                    this.spinner.hide("repoListSpinner");
                    this.snackBar.open(
                      "Collaborator added successfully",
                      "Ok",
                      {
                        duration: 5000,
                      }
                    );
                  },
                  error: (err) => {
                    this.spinner.hide("repoListSpinner");
                    this.snackBar.open("Failed to add collaborator..", "Ok", {
                      duration: 5000,
                    });
                  },
                });
            }
          });
        },
        error: (err) => {
          this.spinner.hide("repoListSpinner");
          console.error("Failed to get collaborators:", err);
          this.snackBar.open("Failed to load collaborators", "Ok", {
            duration: 3000,
          });
        },
      });
  }

  redirectTo(repo: GiteaRepository) {
    const giteaUrl = `${repo.htmlUrl}`;
    if (repo && giteaUrl) {
      window.open(giteaUrl, "_blank");
    }
  }

  // cloneRepoForUser(repo: Repository) {
  //   const editUserDialog = this.dialog.open(SelectRepoUserComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     width: "400px",
  //     height: "600px",
  //     data: {
  //       UserList: this.userList,
  //       title: "Clone Repository for Users",
  //       cancelButtonText: "Cancel",
  //       confirmButtonText: "Clone",
  //     },
  //   });
  //   let cloneRepo: CloneRepositoryInfo = { ...repo, userList: [] };

  //   editUserDialog.afterClosed().subscribe((res) => {
  //     if (res.status) {
  //       res.data.forEach((user) => {
  //         cloneRepo.userList.push(user);
  //       });
  //       this.spinner.show("repoListSpinner");
  //       this.depService.CloneRepoForUser(cloneRepo).subscribe({
  //         next: (data) => {
  //           this.spinner.hide("repoListSpinner");
  //           this.snackBar.open("Download Started in background", "Ok", {
  //             duration: 5000,
  //           });
  //         },
  //         error: (err) => {
  //           this.spinner.hide("repoListSpinner");
  //           this.snackBar.open("Failed to start to download..", "Ok", {
  //             duration: 5000,
  //           });
  //         },
  //       });
  //     }
  //   });
  // }

  goToRepohub() {
    this.snackBar.open("Redirecting to Gitea...", "Ok", {
      duration: 3000,
    });
    this.configEntityService.getGiteaConfig().subscribe({
      next: (data) => {
        const giteaUrl = JSON.parse(JSON.stringify(data));
        if (giteaUrl) {
          window.open(giteaUrl.url, "_blank");
        } else {
          this.snackBar.open("Gitea URL not found", "Ok", {
            duration: 3000,
          });
        }
      },
      error: (err) => {
        console.error(err);
        this.snackBar.open("Failed to load gitea config", "Ok", {
          duration: 3000,
        });
      },
    });
  }

  onSearch() {
    this.filteredRepoList = [...this.giteaRepoList];
    if (this.filterText != "") {
      this.filteredRepoList = this.filteredRepoList.filter((nd) => {
        if (nd.name.toLowerCase().includes(this.filterText.toLowerCase())) {
          return nd;
        }
      });
    }
  }
}
